import Index from './index'

export default {
  path: '/recruiting/agreement-checking',
  component: Index,
  meta: {
    noAuth: true
  }
}
